import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import classNames from "classnames";
import { handleGetRequest } from "../../services/GetTemplate";

function ZDropdown({ onChange, values, isFormFieldValid, getFormErrorMessage, keyName, placeholder, optionLabel, valueOption, url, label, required, onFocus, disabled }) {

    const [options, setOptions] = useState([]);
    const [loading, setloading] = useState(false);
    const placeholderMgs = loading ? "Loading..." : placeholder || "Select";

    useEffect(() => {

        const getDropdownOptions = async () => {
            setloading(true);
            try {
                const res = await handleGetRequest(url);
                const options = res.data.map((item) => {
                    return {
                        label: item[optionLabel],
                        value: item[valueOption],
                    };
                });
                setOptions(options);
            } catch (err) {
                setOptions([]);
                console.log(err);
            } finally {
                setloading(false);
            }
        };

        getDropdownOptions();
    }, []);

    return (
        <>
            <label htmlFor={keyName} className={classNames({ "p-error": isFormFieldValid(keyName.toString()) }, "Label__Text")}>
                {label} {required && <span className="Label__Required">*</span>}
            </label>
            <Dropdown disabled={loading || disabled} id={keyName} placeholder={placeholderMgs} name={keyName} value={values[keyName]} options={options} onChange={onChange} className={classNames({ "p-invalid": isFormFieldValid(keyName.toString()) }, "Dropdown__Round")} onFocus={onFocus} showClear />
            {getFormErrorMessage(keyName.toString())}
        </>
    );
}

export default ZDropdown;
